import {
  isEnergyPitchFunnelSpecificVariant,
  isSocialProofMillionsVariant,
} from 'data/images/utils'
import type { ImagesDefinition } from 'types/images'

export const CHM01_IMAGES = {
  welcomeAgeBuckets: {
    fortyToFortyNine: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chm01/welcome-age-buckets/welcome_age_buckets_option_40_49.webp',
        '/images/chm01/welcome-age-buckets/welcome_age_buckets_option_40_49@2x.webp',
      ],
    },
    fiftyToFiftyNine: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chm01/welcome-age-buckets/welcome_age_buckets_option_50_59.webp',
        '/images/chm01/welcome-age-buckets/welcome_age_buckets_option_50_59@2x.webp',
      ],
    },
    sixtyToSixtyNine: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chm01/welcome-age-buckets/welcome_age_buckets_option_60_69.webp',
        '/images/chm01/welcome-age-buckets/welcome_age_buckets_option_60_69@2x.webp',
      ],
    },
    seventyPlus: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chm01/welcome-age-buckets/welcome_age_buckets_option_70_plus.webp',
        '/images/chm01/welcome-age-buckets/welcome_age_buckets_option_70_plus@2x.webp',
      ],
    },
    heroBackground: {
      width: 651,
      height: 651,
      srcSet: [
        '/images/chm01/welcome-age-buckets/hero_background.webp',
        '/images/chm01/welcome-age-buckets/hero_background@2x.webp',
      ],
    },
    fortyToFortyNineList: {
      width: 96,
      height: 96,
      srcSet: [
        '/images/chm01/welcome-age-buckets/list/welcome_age_buckets_option_40_49.webp',
        '/images/chm01/welcome-age-buckets/list/welcome_age_buckets_option_40_49@2x.webp',
      ],
    },
    fiftyToFiftyNineList: {
      width: 96,
      height: 96,
      srcSet: [
        '/images/chm01/welcome-age-buckets/list/welcome_age_buckets_option_50_59.webp',
        '/images/chm01/welcome-age-buckets/list/welcome_age_buckets_option_50_59@2x.webp',
      ],
    },
    sixtyToSixtyNineList: {
      width: 96,
      height: 96,
      srcSet: [
        '/images/chm01/welcome-age-buckets/list/welcome_age_buckets_option_60_69.webp',
        '/images/chm01/welcome-age-buckets/list/welcome_age_buckets_option_60_69@2x.webp',
      ],
    },
    seventyPlusList: {
      width: 96,
      height: 96,
      srcSet: [
        '/images/chm01/welcome-age-buckets/list/welcome_age_buckets_option_70_plus.webp',
        '/images/chm01/welcome-age-buckets/list/welcome_age_buckets_option_70_plus@2x.webp',
      ],
    },
  },
  socialProofMillions: {
    pitch: {
      width: 370,
      height: 364,
      srcSet: [
        '/images/chm01/social_proof_millions.webp',
        '/images/chm01/social_proof_millions@2x.webp',
      ],
      prefetchCondition: isSocialProofMillionsVariant('default'),
    },
    group: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/chm01/social-proof-millions/group.webp',
        '/images/chm01/social-proof-millions/group@2x.webp',
      ],
      prefetchCondition: isSocialProofMillionsVariant('group'),
    },
  },
  experience: {
    question: {
      width: 369,
      height: 377,
      srcSet: [
        '/images/chm01/experience.webp',
        '/images/chm01/experience@2x.webp',
      ],
    },
    pitch: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chm01/experience_pitch.webp',
        '/images/chm01/experience_pitch@2x.webp',
      ],
    },
  },
  mainGoal: {
    gainMuscle: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/chm01/main-goal/main_goal_option_gain_muscle.webp',
        '/images/chm01/main-goal/main_goal_option_gain_muscle@2x.webp',
      ],
    },
    improveFitness: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/chm01/main-goal/main_goal_option_improve_fitness.webp',
        '/images/chm01/main-goal/main_goal_option_improve_fitness@2x.webp',
      ],
    },
    loseWeight: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/chm01/main-goal/main_goal_option_lose_weight.webp',
        '/images/chm01/main-goal/main_goal_option_lose_weight@2x.webp',
      ],
    },
  },
  physicalBuild: {
    extra: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chm01/physical-build/physical_build_option_significantly_overweight.webp',
        '/images/chm01/physical-build/physical_build_option_significantly_overweight@2x.webp',
      ],
    },
    plusSize: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chm01/physical-build/physical_build_option_bigger.webp',
        '/images/chm01/physical-build/physical_build_option_bigger@2x.webp',
      ],
    },
    average: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chm01/physical-build/physical_build_option_medium_build.webp',
        '/images/chm01/physical-build/physical_build_option_medium_build@2x.webp',
      ],
    },
    skinnySlim: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chm01/physical-build/physical_build_option_slender.webp',
        '/images/chm01/physical-build/physical_build_option_slender@2x.webp',
      ],
    },
  },
  bodyGoal: {
    bitLeaner: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chm01/body-goal/body_goal_option_a_bit_leaner.webp',
        '/images/chm01/body-goal/body_goal_option_a_bit_leaner@2x.webp',
      ],
    },
    athletic: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chm01/body-goal/body_goal_option_athletic.webp',
        '/images/chm01/body-goal/body_goal_option_athletic@2x.webp',
      ],
    },
    shredded: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chm01/body-goal/body_goal_option_shredded.webp',
        '/images/chm01/body-goal/body_goal_option_shredded@2x.webp',
      ],
    },
    extraBulky: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chm01/body-goal/body_goal_option_extra_bulky.webp',
        '/images/chm01/body-goal/body_goal_option_extra_bulky@2x.webp',
      ],
    },
  },
  consistencyPitch: {
    forty: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chm01/consistency-pitch/consistency_pitch_40.webp',
        '/images/chm01/consistency-pitch/consistency_pitch_40@2x.webp',
      ],
    },
    fifty: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chm01/consistency-pitch/consistency_pitch_50.webp',
        '/images/chm01/consistency-pitch/consistency_pitch_50@2x.webp',
      ],
    },
    sixty: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chm01/consistency-pitch/consistency_pitch_60.webp',
        '/images/chm01/consistency-pitch/consistency_pitch_60@2x.webp',
      ],
    },
    seventy: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chm01/consistency-pitch/consistency_pitch_70.webp',
        '/images/chm01/consistency-pitch/consistency_pitch_70@2x.webp',
      ],
    },
    unknown: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chm01/consistency-pitch/consistency_pitch_unknown.webp',
        '/images/chm01/consistency-pitch/consistency_pitch_unknown@2x.webp',
      ],
    },
  },
  flexibility: {
    low: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/chm01/flexibility/flexibility_low.webp',
        '/images/chm01/flexibility/flexibility_low@2x.webp',
      ],
    },
    medium: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/chm01/flexibility/flexibility_medium.webp',
        '/images/chm01/flexibility/flexibility_medium@2x.webp',
      ],
    },
    high: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/chm01/flexibility/flexibility_high.webp',
        '/images/chm01/flexibility/flexibility_high@2x.webp',
      ],
    },
  },
  posture: {
    pitch: {
      width: 370,
      height: 234,
      srcSet: [
        '/images/chm01/posture_pitch.webp',
        '/images/chm01/posture_pitch@2x.webp',
      ],
    },
  },
  problemAreas: {
    belly: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/chm01/problem-areas/problem_areas_option_belly.webp',
        '/images/chm01/problem-areas/problem_areas_option_belly@2x.webp',
      ],
    },
    pecs: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/chm01/problem-areas/problem_areas_option_pecs.webp',
        '/images/chm01/problem-areas/problem_areas_option_pecs@2x.webp',
      ],
    },
    arms: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/chm01/problem-areas/problem_areas_option_arms.webp',
        '/images/chm01/problem-areas/problem_areas_option_arms@2x.webp',
      ],
    },
    thighs: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/chm01/problem-areas/problem_areas_option_legs.webp',
        '/images/chm01/problem-areas/problem_areas_option_legs@2x.webp',
      ],
    },
  },
  struggle: {
    back: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chm01/struggle/struggle_option_back.webp',
        '/images/chm01/struggle/struggle_option_back@2x.webp',
      ],
    },
    knees: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chm01/struggle/struggle_option_knees.webp',
        '/images/chm01/struggle/struggle_option_knees@2x.webp',
      ],
    },
    none: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/chm01/struggle/struggle_option_none.webp',
        '/images/chm01/struggle/struggle_option_none@2x.webp',
      ],
    },
  },
  bodyTypePitch: {
    endomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/chm01/body-type-pitch/body_type_pitch_endomorph.webp',
        '/images/chm01/body-type-pitch/body_type_pitch_endomorph@2x.webp',
      ],
    },
    mesomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/chm01/body-type-pitch/body_type_pitch_mesomorph.webp',
        '/images/chm01/body-type-pitch/body_type_pitch_mesomorph@2x.webp',
      ],
    },
    ectomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/chm01/body-type-pitch/body_type_pitch_ectomorph.webp',
        '/images/chm01/body-type-pitch/body_type_pitch_ectomorph@2x.webp',
      ],
    },
  },
  strugglePitch: {
    knees: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chm01/struggle-pitch/struggle_pitch_knees.webp',
        '/images/chm01/struggle-pitch/struggle_pitch_knees@2x.webp',
      ],
    },
    back: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chm01/struggle-pitch/struggle_pitch_back.webp',
        '/images/chm01/struggle-pitch/struggle_pitch_back@2x.webp',
      ],
    },
    both: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chm01/struggle-pitch/struggle_pitch_both.webp',
        '/images/chm01/struggle-pitch/struggle_pitch_both@2x.webp',
      ],
    },
  },
  stairsCardio: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/chm01/stairs_cardio.webp',
        '/images/chm01/stairs_cardio@2x.webp',
      ],
    },
  },
  howOftenExercise: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/chm01/how_often_exercise.webp',
        '/images/chm01/how_often_exercise@2x.webp',
      ],
    },
  },
  bigResultsPitch: {
    first: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/chm01/big-results-pitch/big_results_pitch_01.webp',
        '/images/chm01/big-results-pitch/big_results_pitch_01@2x.webp',
      ],
    },
    second: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/chm01/big-results-pitch/big_results_pitch_02.webp',
        '/images/chm01/big-results-pitch/big_results_pitch_02@2x.webp',
      ],
    },
    third: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/chm01/big-results-pitch/big_results_pitch_03.webp',
        '/images/chm01/big-results-pitch/big_results_pitch_03@2x.webp',
      ],
    },
  },
  howOftenWalks: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/chm01/how_often_walks.webp',
        '/images/chm01/how_often_walks@2x.webp',
      ],
    },
  },
  energyPitch: {
    person: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chm01/energy-pitch/person.webp',
        '/images/chm01/energy-pitch/person@2x.webp',
      ],
      prefetchCondition: isEnergyPitchFunnelSpecificVariant,
    },
  },
  waterIntake: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chm01/water_intake.webp',
        '/images/chm01/water_intake@2x.webp',
      ],
    },
  },
  sleepDuration: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/chm01/sleep_duration.webp',
        '/images/chm01/sleep_duration@2x.webp',
      ],
    },
  },
  wellnessProfile: {
    extended: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/chm01/wellness-profile/wellness_profile_overweight.webp',
        '/images/chm01/wellness-profile/wellness_profile_overweight@2x.webp',
      ],
    },
    fullFigured: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/chm01/wellness-profile/wellness_profile_bigger.webp',
        '/images/chm01/wellness-profile/wellness_profile_bigger@2x.webp',
      ],
    },
    midSized: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/chm01/wellness-profile/wellness_profile_medium_build.webp',
        '/images/chm01/wellness-profile/wellness_profile_medium_build@2x.webp',
      ],
    },
    slim: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/chm01/wellness-profile/wellness_profile_slender.webp',
        '/images/chm01/wellness-profile/wellness_profile_slender@2x.webp',
      ],
    },
  },
  subscription: {
    realisticBeforeBigger: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_before_bigger.webp',
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_before_bigger@2x.webp',
      ],
    },
    realisticBeforeMediumBuild: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_before_medium_build.webp',
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_before_medium_build@2x.webp',
      ],
    },
    realisticBeforeSignificantlyOverweight: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_before_significantly_overweight.webp',
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_before_significantly_overweight@2x.webp',
      ],
    },
    realisticBeforeSlender: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_before_slender.webp',
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_before_slender@2x.webp',
      ],
    },
    realisticAfterAthletic: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_after_athletic.webp',
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_after_athletic@2x.webp',
      ],
    },
    realisticAfterBitLeaner: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_after_a_bit_leaner.webp',
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_after_a_bit_leaner@2x.webp',
      ],
    },
    realisticAfterExtraBulky: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_after_extra_bulky.webp',
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_after_extra_bulky@2x.webp',
      ],
    },
    realisticAfterShredded: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_after_shredded.webp',
        '/images/chm01/subscription/goal-body/realistic/paywall_comparison_after_shredded@2x.webp',
      ],
    },
  },
} satisfies ImagesDefinition
